function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

export function getUrlFromProps(_ref) {
  let urlPattern = _ref.urlPattern,
      props = _objectWithoutPropertiesLoose(_ref, ["urlPattern"]);

  if (!urlPattern) {
    return undefined;
  } // get url from urlPattern


  const urlParts = urlPattern.split('/');
  const url = urlParts.map(name => {
    let value = name;

    if (name.startsWith(":")) {
      name = name.substr(1);
      value = props[name] || undefined;
    }

    return value;
  });
  return url.join("/");
}
export default getUrlFromProps;